module.exports = __webpack_public_path__ + "static/media/eraser_cursor.005e3607.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/eraser_cursor.cur
// module id = 2315
// module chunks = 0